import { Button } from '@quadminds/mindkit';
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate, Navigate } from 'react-router-dom';
import { useIntegrationContext } from '../../../providers/Integration/Integration.provider';

//TODO: aca falta recuperar el token que devuelva google @JotaRaffalli
const AuthCallback: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { googleIntegration, setGoogleIntegration } = useIntegrationContext();

    const accessToken = searchParams.get('gpc_oauth_token');
    const status = searchParams.get('status');
    const [storingToken, setStoreToken] = React.useState(true);

    useEffect(() => {
        if (accessToken && localStorage.getItem('googleAccessToken') === null && storingToken) {
            localStorage.setItem('googleAccessToken', accessToken);
            setStoreToken(false);
            setGoogleIntegration({
                accessToken: accessToken,
                selfOpenedGooglePicker: true,
            });
        }
    }, [accessToken, navigate, setGoogleIntegration, storingToken]);

    if (status !== 'success') {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <p className="text-red-500 font-semibold">Failed to authenticate with Google.</p>
                <p className="text-gray-500">Please try again in a few minutes.</p>
                <div className="flex justify-center gap-2 items-center">
                    <Button
                        className="w-[190px] mt-4 px-4 py-2 "
                        onClick={() => navigate('/knowledge')}
                        variant="default"
                    >
                        Volver
                    </Button>
                </div>
            </div>
        );
    }

    if (storingToken) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <p className="text-red-500 font-semibold">Storing token</p>
            </div>
        );
    }
    if (!storingToken && status === 'success') {
        return <Navigate to={googleIntegration.originPath} />;
    }

    return null;
};

export default AuthCallback;
